<template>
  <div id="OrgRegisterDialog">
    <el-dialog
      title="用户审批"
      width="898px"
      :visible.sync="isVisibleTemp"
    >
      <div>
        <div class="div-left">
          <div
            class="org-info-busi-license"
            :data-img-preview-src="businessLicenseImgUrl"
            v-image-preview
          >
            <span style="position:relative">
              <img
                style="margin:auto;max-width:400px;max-height:500px;"
                :src="businessLicenseImgUrl"
              >
            </span>
          </div>
        </div>
        <div class="div-right">
          <div class="stepTitle">
            <span>机构申请信息</span>
          </div>
          <div class="panel-body-row">
            <div class="panel-body-row-left">机构名称:</div>
            <div class="panel-body-row-right">{{orgRegisterInfo.departName}}</div>
          </div>
          <div class="panel-body-row">
            <div class="panel-body-row-left">社会信用代码:</div>
            <div class="panel-body-row-right">{{orgRegisterInfo.creditCode}}</div>
          </div>
          <div class="panel-body-row">
            <div class="panel-body-row-left">类型:</div>
            <div class="panel-body-row-right">{{orgRegisterInfo.orgType}}</div>
          </div>
          <div class="panel-body-row">
            <div class="panel-body-row-left ">法定代表人:</div>
            <div class="panel-body-row-right">{{orgRegisterInfo.legalPerson}}</div>
          </div>
          <div class="panel-body-row">
            <div class="panel-body-row-left ">注册资本:</div>
            <div class="panel-body-row-right">{{orgRegisterInfo.registerCapital}}</div>
          </div>
          <div class="panel-body-row">
            <div class="panel-body-row-left">成立日期:</div>
            <div class="panel-body-row-right">{{orgRegisterInfo.foundingDate | dateFormatYMD }}</div>
          </div>
          <div class="panel-body-row">
            <div class="panel-body-row-left">营业期限自:</div>
            <div class="panel-body-row-right">{{orgRegisterInfo.busiTermStart | dateFormatYMD }}</div>
          </div>
          <div class="panel-body-row">
            <div class="panel-body-row-left">营业期限至:</div>
            <div class="panel-body-row-right">{{orgRegisterInfo.busiTermEnd | dateFormatYMD }}</div>
          </div>
          <div class="panel-body-row">
            <div class="panel-body-row-left">登记机关:</div>
            <div class="panel-body-row-right">{{orgRegisterInfo.regOffice}}</div>
          </div>
          <div class="panel-body-row">
            <div class="panel-body-row-left">核准日期:</div>
            <div class="panel-body-row-right">{{orgRegisterInfo.approvalDate | dateFormatYMD }}</div>
          </div>
          <div class="panel-body-row">
            <div class="panel-body-row-left">登记状态:</div>
            <div class="panel-body-row-right">{{orgRegisterInfo.regStatus}}</div>
          </div>
          <div class="panel-body-row">
            <div
              class="panel-body-row-left"
              style="padding-bottom:15px"
            >注册地址:</div>
            <div class="panel-body-row-right rgister-div">
              <el-tooltip
                :content="orgRegisterInfo.registerAddress"
                placement="top"
              >
                <span> {{orgRegisterInfo.registerAddress}}</span>
              </el-tooltip>
            </div>
          </div>
          <div
            class="panel-body-row"
            style="padding-top:5px"
          >
            <div class="panel-body-row-left">经营范围:</div>
            <div class="panel-body-row-right rgister-div">
              <el-tooltip
                :content="orgRegisterInfo.busiScope"
                placement="top"
              >
                <span> {{orgRegisterInfo.busiScope}}</span>
              </el-tooltip>
            </div>
          </div>
          <div
            class="panel-body-row"
            style="padding-top:10px"
          >
            <div class="panel-body-row-left ">审核意见:</div>
            <div class="panel-body-row-right">
              <el-input
                type="textarea"
                class="eb-textarea"
                :disabled="orgRegisterInfo.auditOpinionStatus"
                :rows="6"
                placeholder="请输入审核意见，不超过100字"
                v-model="orgRegisterInfo.auditOpinion"
                :maxlength="100"
              ></el-input>
              <div style="text-align: right;width:100%">
                <span>{{orgRegisterInfo.auditOpinion?100-orgRegisterInfo.auditOpinion.length:100}}/100</span>
              </div>
            </div>

          </div>
        </div>
      </div>
      <div
        slot="footer"
        class="dialog-footer"
      >
        <el-button
          class="eb-button-group-btn eb-button-orange eb-button-big"
          :disabled="orgRegisterInfo.auditedRegisterBtnStatus"
          @click="auditedRegister"
        >批准通过</el-button>
        <el-button
          class="eb-button-group-btn eb-button-orange eb-button-big"
          :disabled="returnEditBtnStatus"
          @click="returnEdit"
        >退回修改</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import { imagePreview } from '@/directives/image-preview';
import { returnEdit, auditedRegister } from '@/services/org/depart-register-service';
export default {
  directives: {
    imagePreview: imagePreview
  },
  props: {
    orgRegisterInfo: {
      type: Object
    },
    isVisible: {
      type: Boolean,
      required: true
    }
  },
  data() {
    return {};
  },

  computed: {
    isVisibleTemp: {
      get: function() {
        return this.isVisible;
      },
      set: function(val) {
        this.$emit('update:isVisible', val);
      }
    },
    businessLicenseImgUrl() {
      return this.orgRegisterInfo.businessLicense ? this.orgRegisterInfo.businessLicense : '';
    },
    returnEditBtnStatus() {
      if (this.orgRegisterInfo.registerStauts !== '1') {
        if (this.orgRegisterInfo.auditOpinion) {
          return !this.orgRegisterInfo.auditOpinion.length > 0;
        } else {
          return true;
        }
      } else {
        return true;
      }
    }
  },
  methods: {
    auditedRegister() {
      this.$ebConfirm('确认通过【' + this.orgRegisterInfo.departName + '】的注册申请？')
        .then(async result => {
          this.$root.layout.isLoading = true;
          try {
            let { data } = await auditedRegister(this.orgRegisterInfo.departRegisterId);
            if (data.returnCode === '01') {
              this.isVisibleTemp = false;
              this.$message.success('操作成功');
              this.$emit('registerSuccess');
            } else if (data.returnCode === '02') {
              this.$root.layout.isLoading = false;
              this.$message.error('机构已在系统中注册');
            } else if (data.returnCode === '03') {
              this.$root.layout.isLoading = false;
              this.$message.error('手机号已在系统中使用');
            } else {
              this.$message.error('通过失败');
            }
          } catch (err) {
            this.$message.error(err);
          }
        })
        .catch(() => {});
      this.$root.layout.isLoading = false;
    },
    returnEdit() {
      this.$ebConfirm('确认退回？').then(async result => {
        var params = {
          departRegisterId: this.orgRegisterInfo.departRegisterId,
          auditOpinion: this.orgRegisterInfo.auditOpinion
        };
        this.$root.layout.isLoading = true;
        try {
          let { data } = await returnEdit(params);
          if (data.returnCode === '01') {
            this.isVisibleTemp = false;
            this.$message.success('退回成功');
            this.$emit('registerSuccess');
          }
        } catch (error) {
          this.$message.error('退回失败');
        }
        this.$root.layout.isLoading = false;
      });
    }
  }
};
</script>
<style lang="less">
#OrgRegisterDialog {
  .el-dialog__body {
    padding: 5px 20px;
    color: #000;
  }
  .div-left {
    float: left;
    width: 400px;
    height: 650px;
    border: 1px solid #9d9d9d;
    font-weight: bold;
    font-size: 18px;
  }
  .div-right {
    float: left;
    width: 400px;
    height: 650px;
    border: 1px solid #9d9d9d;
  }

  .stepTitle {
    padding-top: 10px;
    padding-left: 120px;
    padding-bottom: 10px;
    font-weight: bold;
    font-size: 25px;
  }
  .panel-body-row-left {
    width: 33%;
    padding-left: 10px;
    font-weight: bold;
    font-size: 16px;
    align-items: baseline;
  }
  .panel-body-row-right {
    width: 58%;
    align-items: baseline;
  }
  .dialog-footer {
    text-align: center;
  }
  .eb-button-orange {
    top: 8px;
  }
  .panel-body-row {
    padding: 0px 0;
  }
  .rgister-div {
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    cursor: pointer;
  }
}
</style>
